import { useCallback } from 'react';
import { PowerdBy } from '../../assets/powerdBy';
import { FooterContainer } from './styles';

const Footer = () => {
  const onClick = useCallback(() => {
    window.open('https://particle.network', '_blank');
  }, []);
  return (
    <FooterContainer>
      <PowerdBy onClick={onClick}></PowerdBy>
    </FooterContainer>
  );
};

export default Footer;
